import ApplicationSerializer from 'eflex/serializers/application';

export default class HardwareIoSerializer extends ApplicationSerializer {
  attrs = {
    hardwareInputDefs: {
      deserialize: false,
      serialize: false,
    },
  };
}
